export const SUPPORT_CHAT_PROMPT_DELAY = 5000
export const SUPPORT_CHAT_PROMPT_VISIBLE_MS = 10000

export function canShowSupportChatPrompt({ isOpen, dismissed, delayElapsed }) {
  return !isOpen && !dismissed && delayElapsed
}
